import { Box } from '@mui/material';
import HtmlDisplayer from 'react-components/components/HtmlDisplayer';

interface ConsentTermCopyProps {
  copy: string;
}

const ConsentTermCopy = ({ copy }: ConsentTermCopyProps) => {
  return (
    <Box
      sx={{
        padding: 2,
        backgroundColor: '#ffffff',
        borderRadius: 2,
        boxSizing: 'border-box',
      }}
    >
      <HtmlDisplayer innerHtml={copy} />
    </Box>
  );
};

export default ConsentTermCopy;
